/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/

import { environment } from "../../environments/environment";

export class Constants {
  public static API_COMMON_URL = `${environment.baseContext}/commonapi`;
  public static ENTITY_BASE_URL = '/entityAttribute';
  public static SCREEN_BASE_URL = '/screen';
  public static CONTROL_TYPE_TEXTBOX = 'textbox';
  public static CONTROL_TYPE_CHECKBOX = 'checkbox';
  public static CONTROL_TYPE_DROPDOWN = 'dropdown';
  public static CONTROL_TYPE_DATEPICKER = "datepicker";
  public static CONTROL_TYPE_CUSTOM_DATEPICKER = "customdatepicker";

  public static NOTIFICATION_BASE_URL = `${environment.baseContext}/notificationapi`;
  public static NOTIFICATION_API_BASE_URL = '/notify/inapp';
  public static MODEL_DETAIL_ROUTE_URL = '/tpe/model-detail/';
  public static EDA_DETAIL_ROUTE_URL = '/tpe/eda-detail/';
  public static PROJECT_DETAIL_ROUTE_URL = '/tpe/project-detail/';
  public static TPE_NOTIFICATION_LIST_ROUTE_URL = '/tpe/show-notification';
  public static TIME_SERIES_DETAIL_ROUTE_URL = '/tpe/timeseries-details/';

  public static PATTERN_NUMERIC = "^[0-9]+$";
  public static PATTERN_ALPHANUMERIC = "^([a-zA-Z0-9,.!@#$%^&*()_-]+ )*[a-zA-Z0-9,.!@#$%^&*()_-]+$";
  public static PATTERN_DECIMAL = "^[0-9]+(\\.[0-9]{1,3})?$";
  public static HIERARCHY_NUMERIC = "^[1-4]?";
  public static DEFAULT_LANGUAGE = 'en_us';
}


